'use client';

import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import Link from '@/components/Link';
import MapSectionWrapper from '@/components/MapSection';
import colors from '@/styles/themes/colors';

import styles from './MapSection.module.scss';

const MapSection = () => {
  const t = useTranslations('career');

  return (
    <>
      <MapSectionWrapper>
        <Stack spacing={3}>
          <Typography variant="h2" color={colors.white} maxWidth={800}>
            {t('mapSection.title')}
          </Typography>
          <Link text={t('mapSection.link')} href="/office" />
        </Stack>
      </MapSectionWrapper>
      <Container component="section" maxWidth="xl" className={styles.container}>
        <Grid container spacing={2} width="100%">
          <Grid size={{ xs: 8, lg: 6 }}>
            <Box className={styles.imageWrapper}>
              <Image
                src="/images/home/team/team1.webp"
                alt="Our Team"
                fill
                style={{ objectFit: 'cover' }}
                className={styles.image}
                sizes="(min-width: 1200px) 42vw, 66vw"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 4, lg: 3 }}>
            <Box className={styles.imageWrapper}>
              <Image
                src="/images/home/team/team3.webp"
                alt="Our Team"
                fill
                style={{ objectFit: 'cover' }}
                className={styles.image}
                sizes="(min-width: 1200px) 29vw, 33vw"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 3 }}>
            <Box className={styles.imageWrapper}>
              <Image
                src="/images/home/team/team2.webp"
                alt="Our Team"
                fill
                style={{ objectFit: 'cover' }}
                className={styles.image}
                sizes="(min-width: 1200px) 29vw, 33vw"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }}>
            <Box className={styles.imageWrapper}>
              <Image
                src="/images/home/team/team4.webp"
                alt="Our Team"
                fill
                style={{ objectFit: 'cover' }}
                className={styles.image}
                sizes="(min-width: 1200px) 37vw, 100vw"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 4, lg: 5 }}>
            <Box className={styles.imageWrapper}>
              <Image
                src="/images/home/team/team6.webp"
                alt="Our Team"
                fill
                style={{ objectFit: 'cover' }}
                className={styles.image}
                sizes="(min-width: 1200px) 37vw, 66vw"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 8, lg: 3 }}>
            <Box className={styles.imageWrapper}>
              <Image
                src="/images/home/team/team7.webp"
                alt="Our Team"
                fill
                style={{ objectFit: 'cover' }}
                className={styles.image}
                sizes="(min-width: 1200px) 25vw, 33vw"
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MapSection;
